import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { useCart } from '../../context/CartContext';

export default function ProductCard({ product }) {
  const { addToCart } = useCart();
  const [isAdding, setIsAdding] = useState(false);

  const handleAdd = (e) => {
    e.preventDefault();
    setIsAdding(true);
    addToCart(product);
    setTimeout(() => setIsAdding(false), 1500);
  };

  return (
    <div className="group cursor-pointer flex flex-col h-full bg-white transition-all duration-700 border border-creamDark overflow-hidden focus-within:ring-2 focus-within:ring-saddle focus-within:ring-offset-2 outline-none" tabIndex="0">
      {/* Image Container */}
      <div className="relative aspect-[4/5] overflow-hidden bg-creamDark">
        <img 
          src={product.image} 
          alt={product.name}
          className="w-full h-full object-cover object-center group-hover:scale-110 transition-transform duration-[2000ms]"
          loading="lazy"
        />
        
        {product.badge && (
          <div className="absolute top-4 left-4 bg-navy text-cream px-3 py-1 text-[9px] font-bold uppercase tracking-[0.2em] z-10">
            {product.badge}
          </div>
        )}

        <div className="absolute inset-0 bg-navy/30 opacity-0 group-hover:opacity-100 transition-all duration-500 flex items-end p-6">
          <button 
            onClick={handleAdd}
            disabled={isAdding}
            className={`w-full py-4 font-sans text-[10px] tracking-[0.3em] uppercase flex items-center justify-center gap-3 shadow-2xl transform translate-y-4 group-hover:translate-y-0 transition-all duration-500 ${
              isAdding ? 'bg-green-600 text-white translate-y-0' : 'bg-cream text-navy hover:bg-saddle hover:text-white'
            }`}
          >
            {isAdding ? (
              <><SafeIcon icon={FiIcons.FiCheck} /> Added</>
            ) : (
              <><SafeIcon icon={FiIcons.FiPlus} /> Quick Add</>
            )}
          </button>
        </div>
      </div>

      <div className="p-6 flex flex-col flex-grow">
        <div className="flex justify-between items-start gap-4 mb-3">
          <h3 className="font-serif text-lg text-navy leading-tight group-hover:text-saddle transition-colors">{product.name}</h3>
          <span className="font-sans text-sm font-semibold text-brass">${product.price}</span>
        </div>
        <p className="font-sans text-[11px] text-navy/50 leading-relaxed line-clamp-2 mb-4">
          {product.desc}
        </p>
        <div className="mt-auto pt-4 border-t border-creamDark flex items-center justify-between">
          <span className="font-sans text-[9px] uppercase tracking-widest text-navy/40">{product.category} collection</span>
          <div className="flex gap-0.5" aria-hidden="true">
            {[...Array(5)].map((_, i) => (
              <SafeIcon key={i} icon={FiIcons.FiStar} className="w-2.5 h-2.5 fill-brass text-brass" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}